import config from 'config';
import { Link } from 'react-router-dom';
import { isGlobant } from 'utils/contants';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Navbar from '../index.jsx';
import './header.scss';

const Img = styled.img`
  width: ${(props) => props.width || '120px'};
`;

const Header = ({ user }) => {
  const { t } = useTranslation();
  return (
    <header>
      {!isGlobant && (
        <div className="header-custom bg-light d-flex align-items-center position-relative py-3 header-padding">
          <Link to="/">
            <Img
              src={config.logo}
              width={config.logo_width}
              className="d-inline-block align-top logo-reactour"
              alt="logo"
            />
          </Link>
          {/* Link para redireccionar a donaronline de cada enlatado cuando exista la funcionalidad */}
          {/* <a className="premium-btn" href="https://donaronline.org/" target="_blank" role="button" rel="noreferrer">
            <IoIosUnlock />
            <span className="d-none d-sm-inline">{t('header.header_msg11')}</span>
            <span className="d-inline d-sm-none">{t('header.header_msg12')}</span>
          </a> */}
        </div>
      )}
      <Navbar user={user} />
    </header>
  );
};

export default Header;
